import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const benchmarkStudyImporterSelectors = importerSelectors(
  'benchmarkStudy.importer',
);

export default benchmarkStudyImporterSelectors;
